"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportClassification = exports.GameSourceType = exports.GameGrouping = void 0;
var GameGrouping;
(function (GameGrouping) {
    GameGrouping["WEEK"] = "week";
    GameGrouping["PHASES"] = "phases";
})(GameGrouping = exports.GameGrouping || (exports.GameGrouping = {}));
var GameSourceType;
(function (GameSourceType) {
    GameSourceType["CALENDAR"] = "calendar";
    GameSourceType["TEAM"] = "team";
})(GameSourceType = exports.GameSourceType || (exports.GameSourceType = {}));
var SportClassification;
(function (SportClassification) {
    SportClassification["ESPORT"] = "esport";
    SportClassification["SPORT"] = "sport";
})(SportClassification = exports.SportClassification || (exports.SportClassification = {}));
